import React from 'react';
import Slider from 'react-slick';
import '../assets/css/TestimonialCarousel.css'; // Optional: For custom styles
import 'slick-carousel/slick/slick.css';

import 'slick-carousel/slick/slick-theme.css';



const ServicesSlider = () => {
  const settings = {
    infinite: true,  // Enables infinite looping
    speed: 500,      // Transition speed (ms)
    slidesToShow: 5, // Number of slides to show at once
    slidesToScroll: 1, // Number of slides to scroll at once
    autoplay: true,  // Automatically slide at a regular interval
    autoplaySpeed: 3000, // Interval for autoplay (in ms)
    dots: false,      // Show navigation dots
    arrows: true,    // Show next and previous arrows
    centerMode: false, // Center the active slide
    focusOnSelect: false, // Focus on the selected slide
    responsive: [
      {
        breakpoint: 1200,  
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,  
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,  
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 552,  
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  return (
      <Slider {...settings}>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/interior.jpg')} alt="Interior and Exterior 
Painting" className='img-fluid' />
                <div className='content'>
                    <h4>Interior and Exterior 
                    Painting</h4>
                    <p>Professional painting with high-quality
                    finishes that last.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/railing.jpg')} alt="Railing and Handrails" className='img-fluid' />
                <div className='content'>
                    <h4>Railing and Handrails</h4>
                    <p>Safe and stylish railing installations.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/gutters.jpg')} alt="Gutters" className='img-fluid' />
                <div className='content'>
                    <h4>Gutters</h4>
                    <p>Repair, cleaning, and replacement of
                    gutters to protect your structure.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/pavers.jpg')} alt="Pavers" className='img-fluid' />
                <div className='content'>
                    <h4>Pavers</h4>
                    <p>Installation of paving stones for 
                    driveways, patios, and outdoor spaces.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/porches.jpg')} alt="Porches" className='img-fluid' />
                <div className='content'>
                    <h4>Porches</h4>
                    <p>Custom porch construction designed for comfort and style.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/fences.jpg')} alt="Fences" className='img-fluid' />
                <div className='content'>
                    <h4>Fences</h4>
                    <p>Installation and maintenance of fences that add security and aesthetic
                    value.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/siding.jpg')} alt="siding" className='img-fluid' />
                <div className='content'>
                    <h4>Siding</h4>
                    <p>Installation of siding to improve both appearance and protection.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/molding.jpg')} alt="Molding and Framing" className='img-fluid' />
                <div className='content'>
                    <h4>Molding and Framing</h4>
                    <p>Carpentry details that bring elegance and character to each
                    space.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/concret.jpg')} alt="Concrete Work" className='img-fluid' />
                <div className='content'>
                    <h4>Concrete Work</h4>
                    <p>Quality concrete work for everything from foundations to
decorative surfaces.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/monsoory.jpg')} alt="Masonry" className='img-fluid' />
                <div className='content'>
                    <h4>Masonry</h4>
                    <p>Full masonry services for all types of projects.</p>
                </div>
              </div>
        </div>
        <div className="testimonial-item">
              <div className="services-items">
                <img src={require('../assets/img/services/remolding.jpg')} alt="Interior and Exterior Remodeling" className='img-fluid' />
                <div className='content'>
                    <h4>Interior and Exterior Remodeling</h4>
                    <p>Transformative remodeling solutions for indoor
and outdoor spaces.</p>
                </div>
              </div>
        </div>
        {/* Add more testimonial items here */}
      </Slider>
  );
};

export default ServicesSlider;
